import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-legacy-redirect-modal',
  standalone: true,
  templateUrl: './legacy-redirect-modal.component.html',
  styleUrls: ['./legacy-redirect-modal.component.scss'],
})
export class LegacyRedirectModalComponent {
  readonly platformUrl = 'https://platform.fairsupply.com';

  constructor(public bsModalRef: BsModalRef) {}
}
